<template>
    <MaskLayout :isShow="notice" @closeMask="closeNotice" :contentStyle="noticeStyle" :animationToTop="true">
        <div class="page-wrapper page-overflow-hidden padding30">
            <p class="page-text-center page-margin-bottom2">{{title}}</p>
            <ul class="page-wrapper notice-content-wrapper">
                <li class="mask-top-wrapper padtb20" v-for="(item, index) in noticeList" :key="index">
                    <p class="font-color-red page-margin-bottom1">{{item.title}}</p>
                    <div v-for="(val, ind) in item.content" :key="ind" v-html="val.content"></div>
                </li>
            </ul>
            <div class="page-margin-top3 movie-box page-text-center movie-gradient notice-button" @click="closeNotice(false)">确认</div>
        </div>
    </MaskLayout>
</template>

<script>
import MaskLayout from "@components/MaskLayout.vue";
export default {
    name: "TicketNotice",
    components: {
        MaskLayout
    },
    props: {
        noticeList: {
            type: Array,
            default: ()=>[]
        },
        notice: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "预订须知"
        }
    },
    data: function () {
        return {
            noticeStyle: {
                width: "100%",
                height: "8rem",
                left: "0%",
                bottom: "0",
                "z-index": "111",
                "border-radius": ".2rem .2rem 0 0"
            }
        };
    },
    methods: {
        closeNotice: function (val) { //预订须知
            this.$emit('noticeClose', val);
        },
    }
}
</script>

<style scoped>
.notice-content-wrapper {
    height: 5.9rem;
}
.mask-top-wrapper {
    border-bottom: .02rem solid #eee;
}
.notice-button {
    height: .7rem;
    line-height: .7rem;
    color: #fff;
    border-radius: .2rem;
}
</style>